import React from 'react'
import Edit from '../../crud/edit'

const fields = [
  {
    name: 'Default Interests',
    prop: 'value',
    type: 'chipinput'
  }
]

const EditSettings = props => {
  return (
    <Edit
// @ts-ignore
      title='Edit MailChimp Default Interests'
      fields={fields}
      apiPath='admin/settings/mailchimp_default_interests'
      successRedirectPath='/settings'
      buildMenuItems={() => {}}
      disableDelete
    />
  )
}

export default EditSettings
